module.exports = __webpack_public_path__ + "a8a61cc2042548facb1b5cdd561062d2.svg";